(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-recommendations"] && !Shopify.designMode) return;
  try {
    
  const initializeRecommendations = (section) => {
    if (section.dataset.qhaInitialized) return;
    section.dataset.qhaInitialized = 'true';
    const track = section.querySelector('[data-recommendation-track]');
    const cards = [...section.querySelectorAll('[data-recommendation-card]')];
    const dots = [...section.querySelectorAll('[data-recommendation-dot]')];
    const videos = [...section.querySelectorAll('video')];
    if (!track) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const visibleVideos = new Set();
    const syncVideo = (video) => {
      if (!visibleVideos.has(video) || document.hidden || reducedMotion.matches) {
        video.pause();
        return;
      }
      video.muted = true;
      const playback = video.play();
      if (playback) playback.catch(() => { video.controls = true; });
    };
    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      if (reducedMotion.matches) video.autoplay = false;
    });
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
          visibleVideos.add(entry.target);
        } else {
          visibleVideos.delete(entry.target);
        }
        syncVideo(entry.target);
      });
    }, { threshold: [0, 0.3] });
    videos.forEach((video) => videoObserver.observe(video));
    const syncPlayback = () => videos.forEach(syncVideo);
    document.addEventListener('visibilitychange', syncPlayback);
    reducedMotion.addEventListener('change', syncPlayback);

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: cards[index].offsetLeft - track.offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
    });
    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(cards.indexOf(entry.target));
      });
    }, { root: track, threshold: 0.7 });
    cards.forEach((card) => cardObserver.observe(card));
    const cleanup = (event) => {
      if (event.target !== section && !event.target.contains(section)) return;
      videoObserver.disconnect();
      cardObserver.disconnect();
      videos.forEach((video) => video.pause());
      document.removeEventListener('visibilitychange', syncPlayback);
      reducedMotion.removeEventListener('change', syncPlayback);
      document.removeEventListener('shopify:section:unload', cleanup);
      delete section.dataset.qhaInitialized;
    };
    document.addEventListener('shopify:section:unload', cleanup);
  };
  document.querySelectorAll('[id^="QhaRecommendations-"]').forEach(initializeRecommendations);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[id^="QhaRecommendations-"]').forEach(initializeRecommendations);
  });

  } catch(e) { console.error(e); }
})();
})();
